export const helmet_url = "https://belgiumwebnetnew.com";
export const postHeader = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const baseURL = "https://belgiumwebnet.com/webapi/api";
